<template>
  <div class="date_select">
    <input type="hidden" :name="inputName" :value="date" />

    <div class="field_group date_day_set">
      <div class="select_ui date_year">
        <select v-model="innerEra" @change="changeValueWareki">
          <option v-for="v in options.eras" v-bind:value="v.value">
            {{ v.label }}
          </option>
        </select>
      </div>
      <!-- /.select_ui -->
      <div class="select_ui date_day_set">
        <select v-model="innerWarekiYear" @change="changeValue">
          <option value="">年</option>
          <option v-for="v in options.years[innerEra]" v-bind:value="v.value">
            {{ v.label }}
          </option>
        </select>
      </div>
      <!-- /.select_ui -->
      <div class="select_ui date_month">
        <select v-model="innerMonth" @change="changeValue">
          <option v-for="v in options.months" v-bind:value="v.value">
            {{ v.label }}
          </option>
        </select>
      </div>
      <!-- /.select_ui -->
      <div class="select_ui date_day">
        <select v-model="innerDay" @change="changeValue">
          <option v-for="v in options.days" v-bind:value="v.value">
            {{ v.label }}
          </option>
        </select>
      </div>
      <!-- /.select_ui -->
    </div>
    <!-- /.field_group.date_day_set -->
  </div>
  <!-- /.date_select -->
</template>

<script>
import { sprintf } from "sprintf-js";

const ERA_HEISEI = "H";
const ERA_REIWA = "R";

export default {
  props: {
    inputName: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        years: this.getWarekiYearsList(),
        months: this.getMonthsList(),
        days: this.getDaysList(),
        eras: this.getErasList(),
      },
      innerWarekiYear: "",
      innerMonth: "",
      innerDay: "",
      innerEra: "",
    };
  },
  created() {
    this.initValue();
  },
  methods: {
    initValue() {
      this.setInnerDate(this.date);
    },
    setInnerDate(date) {
      let parsed = this.parseWarekiDate(date);
      this.innerEra = parsed.era;
      this.innerWarekiYear = parsed.warekiYear;
      this.innerMonth = parsed.month;
      this.innerDay = parsed.day;
    },
    changeValueWareki() {
      this.innerWarekiYear = "";
      this.changeValue();
    },
    changeValue() {
      //this.innerWarekiYear = this.sanitizeWarekiYear(this.innerWarekiYear);
      let date = this.createWarekiDate(
        this.innerEra,
        this.innerWarekiYear,
        this.innerMonth,
        this.innerDay
      );
      this.$emit("update:date", date);
    },
    sanitizeWarekiYear(value) {
      value = String(value);
      return value.replace(/[^0-9]/g, "");
    },
    parseWarekiDate(date) {
      let tmp,
        era = "",
        warekiYear = "",
        month = "",
        day = "";
      tmp = String(date).split("-");

      if (tmp.length === 4) {
        tmp[1] = parseInt(tmp[1], 10);
        tmp[2] = parseInt(tmp[2], 10);
        tmp[3] = parseInt(tmp[3], 10);

        if (tmp[0] === ERA_HEISEI || tmp[0] === ERA_REIWA) {
          era = tmp[0];
        }
        if (!isNaN(tmp[1]) && tmp[1] >= 1 && tmp[1] <= 99) {
          warekiYear = tmp[1];
        }
        if (!isNaN(tmp[2]) && tmp[2] >= 1 && tmp[2] <= 12) {
          month = tmp[2];
        }
        if (!isNaN(tmp[3]) && tmp[3] >= 1 && tmp[3] <= 31) {
          day = tmp[3];
        }
      }

      return { era, warekiYear, month, day };
    },
    createWarekiDate(era, warekiYear, month, day) {
      let ret = { era: "X", warekiYear: 0, month: 0, day: 0 };

      if (era === "" && warekiYear === "" && month === "" && day === "") {
        return "";
      }

      warekiYear = parseInt(warekiYear, 10);
      month = parseInt(month, 10);
      day = parseInt(day, 10);

      if (era === ERA_HEISEI || era === ERA_REIWA) {
        ret.era = era;
      }
      if (!isNaN(warekiYear) && warekiYear >= 1 && warekiYear <= 99) {
        ret.warekiYear = warekiYear;
      }
      if (!isNaN(month) && month >= 1 && month <= 12) {
        ret.month = month;
      }
      if (!isNaN(day) && day >= 1 && day <= 31) {
        ret.day = day;
      }

      return sprintf(
        "%s-%02d-%02d-%02d",
        ret.era,
        ret.warekiYear,
        ret.month,
        ret.day
      );
    },
    getYearsList() {
      let list = [];
      list.push({ value: "", label: "年" });

      for (let i = this.yearMin; i <= this.yearMax; i++) {
        if (this.withWareki) {
          let wareki = this.getWareki(i);
          list.push({
            value: i,
            label: sprintf("%04d (%s%02d)", i, wareki.gengo, wareki.year),
          });
        } else {
          list.push({ value: i, label: sprintf("%04d", i) });
        }
      }

      return list;
    },
    getWarekiYearsList() {
      let difference =
        this.inputName === "driver_license_expiration_date" ? 2013 : 2018;
      let reiwia = [];
      let heisei = [];
      this.getRangeWarekiNen(new Date().getFullYear() - difference).map((v) => {
        reiwia.push({ value: v.trim(), label: v });
      });
      this.getRangeWarekiNen(31).map((v) => {
        heisei.push({ value: v.trim(), label: v });
      });
      console.log( {
        R: reiwia,
        H: heisei,
      });
      return {
        R: reiwia,
        H: heisei,
      };
    },
    getMonthsList() {
      let list = [];
      list.push({ value: "", label: "月" });

      for (let i = 1; i <= 12; i++) {
        list.push({ value: i, label: sprintf("%02d", i) });
      }

      return list;
    },
    getDaysList() {
      let list = [];
      list.push({ value: "", label: "日" });

      for (let i = 1; i <= 31; i++) {
        list.push({ value: i, label: sprintf("%02d", i) });
      }

      return list;
    },
    getErasList() {
      return [
        { value: "", label: "元号" },
        { value: ERA_HEISEI, label: "平成" },
        { value: ERA_REIWA, label: "令和" },
      ];
    },
    getRangeWarekiNen(max) {
      var arr = [];
      for (let i = 1; i <= max; i++) {
        arr.push(i);
      }
      return arr
        .filter(function (x) {
          return x > 0;
        })
        .map(function (x) {
          return (" " + x).slice(-2); // pad with leading space
        });
    },
  },
};
</script>
